import { useForm } from "@inertiajs/react";
import { sessionMagicLinkPath } from "@travily/routes";
import type MagicLinksShow from "@travily/types/pages/MagicLinksShow";
import { type ReactNode, useState } from "react";
import { RoutedModal } from "@/components/RoutedModal";
import { usePrecognitionFields } from "@/lib/forms/use-precognition-fields";
import { inboxUrlFor } from "./components/SentStep";
import { SessionMagicLinkView } from "./show.view";

const SessionMagicLinkPage = ({ masked_email }: MagicLinksShow) => {
  const [step, setStep] = useState<"form" | "sent">("form");
  const path = sessionMagicLinkPath();

  const form = useForm<{ email: string }>({ email: "" }).withPrecognition("post", path).setValidationTimeout(400);
  // Email validates on blur (not mid-type) and escalates to on-change once it has errored.
  const { bindField } = usePrecognitionFields(form);
  const email = bindField("email", { validateOn: "blur" });

  const handleSubmit = () => {
    form.post(path, {
      preserveState: true,
      onSuccess: () => setStep("sent"),
    });
  };

  const goBackToForm = () => setStep("form");

  return (
    <RoutedModal size="sm">
      {({ close }) => (
        <SessionMagicLinkView
          email={email.value}
          emailError={email.errorMessage}
          inboxUrl={inboxUrlFor(form.data.email)}
          isPending={form.processing}
          maskedEmail={masked_email}
          onBack={goBackToForm}
          onClose={close}
          onEmailBlur={email.onBlur}
          onEmailChange={email.onChange}
          onSubmit={handleSubmit}
          step={step}
        />
      )}
    </RoutedModal>
  );
};

SessionMagicLinkPage.layout = (page: ReactNode) => page;

export default SessionMagicLinkPage;
